import axios from "axios";

const API_URL = process.env.NEXT_PUBLIC_BACKEND_URL;

export const getAllCompanies = async (
  currentPage,
  pageSize = 12,
  selectedExchanges = [],
  ticker = "",
  selectedIndustry = [],
  frcCovered = false,
  marketCapGreaterThan = 0,
  marketCapLesserThan = Number.MAX_SAFE_INTEGER,
  sortOrder,
  filterBy = "name"
) => {
  const params = new URLSearchParams({
    page: currentPage,
    pageSize: pageSize,
    ticker: ticker,
    exchange: selectedExchanges?.join(","),
    industry: selectedIndustry?.join(","),
    frc: frcCovered,
    marketCapGreaterThan: marketCapGreaterThan,
    marketCapLessThan: marketCapLesserThan,
    sort: sortOrder,
    sortType: filterBy,
  });

  // Conditionally add parameters only if they have values
  if (!selectedExchanges.length) params.delete("exchange");
  if (!sortOrder) params.delete("sort");
  if (!selectedIndustry.length) params.delete("industry");
  if (!ticker) params.delete("ticker");
  if (frcCovered === false) params.delete("frc");
  if (marketCapGreaterThan === 0) params.delete("marketCapGreaterThan");
  if (marketCapLesserThan === Number.MAX_SAFE_INTEGER)
    params.delete("marketCapLessThan");

  try {
    const response = await axios.get(`${API_URL}/companies`, {
      params,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    console.error("Error fetching companies:", error);
    throw error;
  }
};

export const getPrivateCompanies = async (token, page) => {
  return await axios.get(`${API_URL}/private-companies?page=${page}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getPrivateCompany = async (token, companyId) => {
  return await axios.get(`${API_URL}/private-companies/${companyId}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const cache = {};

export const getCompanyReports = async (ticker) => {
  const response = await axios.get(`${API_URL}/companies/${ticker}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  const data = await response.data.data;

  return data;
};

export const toggleCompanyLike = async (token, ticker = "", id = "") => {
  if (id !== "") {
    return await axios.post(
      `${API_URL}/companies/like`,
      {
        id,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  return await axios.post(
    `${API_URL}/companies/like`,
    {
      ticker,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getCompanyLiked = async (ticker = "", token, companyId = "") => {
  if (companyId !== "") {
    return await axios.post(
      `${API_URL}/companies/userLikes`,
      {
        id: companyId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );
  }

  return await axios.post(
    `${API_URL}/companies/userLikes`,
    {
      ticker,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
};
